import { blobUrlToCompressedFile } from "src/helpers/blobUrlToCompressedFile";
import newApi from "src/newApi";

export async function uploadHtmlBlobImages(html: string): Promise<string> {
	if (!html || !/src="(blob|data):/.test(html)) {
		return html;
	}

	const parser = new DOMParser();
	const doc = parser.parseFromString(html, "text/html");
	const imgs = Array.from(doc.querySelectorAll("img"));

	let changed = false;
	for (const img of imgs) {
		const src = img.getAttribute("src");
		if (src?.startsWith("blob:") || src?.startsWith("data:")) {
			const file = await blobUrlToCompressedFile(src);
			const result = await newApi.uploadImage(file);
			if (result?.url) {
				img.setAttribute("src", result.url);
				changed = true;
			}
		}
	}

	return changed ? doc.body.innerHTML : html;
}
